/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@softeq/core';
import { QuoteService, GithubService } from './resources';
import { AppComponent } from './app.component';
import { HeaderComponent, ExplorerComponent } from './components';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ExplorerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModule,
  ],
  providers: [
    QuoteService,
    GithubService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
